<template>
  <div class="logout cursor-pointer d-flex align-items-center" @click="logout">
    <span class="icon mx-2"
      ><img
        src="https://cdn.vexels.com/img/logout.png"
        :alt="$t('main.header.logOutSection.logoutIconAlt')"
        width="20"
        height="20"
        loading="lazy"
      />
    </span>
    <span>{{ $t('main.header.logOutSection.text') }}</span>
  </div>
</template>

<script>
export default {
  methods: {
    logout() {
      this.$auth.logout();
      this.$store.dispatch('updateUserDataIntercom');
      this.$bvModal.hide('profile-menu-modal');
      this.$store.commit('downloads/SET_DOWNLOAD_PERMISSION', []);
      this.$store.commit('user/SET_LIKED_VECTORS', []);
      this.$cookies.remove('vx.hideBannerB');
    }
  }
};
</script>

<style lang="scss" scoped>
.logout {
  color: black;
  padding: 24px 25px;
  &:hover {
    background: $lightGray;
    border-radius: 0 0 15px 15px;
  }
}
.icon {
  color: $gray;
  margin-right: 10px;
}
</style>
